import styled from 'styled-components';

import { Color } from '../../../../constants/Colors';
import { FontSize, FontType, FontWeight } from '../../../../constants/Fonts';
import { MediaQuery, Transition } from '../../../../constants/Styles';

export const TabList = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;

  ${MediaQuery.XL_AND_DOWN} {
    margin-top: 10px;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  ${MediaQuery.M_AND_DOWN} {
    flex-direction: column;
    flex-wrap: initial;
    justify-content: initial;
  }
`;

export const TabName = styled.button`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.L};
  font-weight: ${({ isCurrentTab }) =>
    isCurrentTab ? FontWeight.BLACK : FontWeight.REGULAR};
  height: 45px;
  cursor: pointer;
  color: ${({ isCurrentTab, customColor }) =>
    isCurrentTab ? customColor : Color.DOLPHIN};
  background-color: ${({ isCurrentTab, colorRGB }) =>
    isCurrentTab ? colorRGB : 'transparent'};
  border: none;
  padding: 0 15px;
  border-radius: 22.5px;
  border: 2px solid transparent;
  box-sizing: border-box;
  background-clip: padding-box;
  transition: ${Transition.ALL_EASE};

  &:hover {
    background-color: ${({ isCurrentTab, colorRGB }) =>
      isCurrentTab ? colorRGB : Color.WHISPER};
  }

  ${MediaQuery.XL_AND_DOWN} {
    border-radius: 8px;
    min-height: 45px;
    height: unset;
  }
`;
